// ** React Imports
import { useCallback, useEffect, useState } from 'react'


import { useTranslation } from 'src/utils/i18n'

// ** MUI Imports
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

// ** Store & Actions Imports
import { useDispatch, useSelector } from 'react-redux'
import {
  selectMessage,
  fetchUserProfile,
  fetchChatsContacts,
  removeSelectedChat
} from 'src/store/apps/android-whatsapp'

// ** Hooks
import { useSettings } from 'src/@core/hooks/useSettings'

// ** Utils Imports
import { getInitials } from 'src/@core/utils/get-initials'
import { formatDateToMonthShort } from 'src/@core/utils/format'

// ** Chat App Components Imports
import WhatsAppSideBar from 'src/@core/components/android/whatapp/whatapp-side-bar'
import WhatsAppContent from 'src/@core/components/android/whatapp/whatapp-content'
import WhatsAppTelephone from 'src/@core/components/android/whatapp/whats-call'
import WhatsAppContacts from 'src/@core/components/android/whatapp/whatsapp-contacts'

// components
import EncryptionKey from 'src/@core/components/android/encryption-key'
import { setCurrentTab } from 'src/store/apps/Common'
import { useDeviceScopedInit } from 'src/hooks/useDeviceScopedInit'
import ContentLoading from 'src/components/ContentLoading'

const WhatsApp = () => {
  let Basic = window.localStorage.getItem('Basic')
  Basic = Basic == null || Basic == 0 ? true : false

  // ** States
  const [userStatus, setUserStatus] = useState('online')
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false)
  const [userProfileLeftOpen, setUserProfileLeftOpen] = useState(false)
  const [userProfileRightOpen, setUserProfileRightOpen] = useState(false)

  // ** Hooks
  const theme = useTheme()
  const { settings } = useSettings()
  const dispatch = useDispatch()
  const hidden = useMediaQuery(theme.breakpoints.down('lg'))

  const store = useSelector(state => state.androidWhatsapp)
  const storeCommon = useSelector(state => state.Common)

  // ** Vars
  const { skin } = settings
  const smAbove = useMediaQuery(theme.breakpoints.up('sm'))
  const sidebarWidth = smAbove ? 370 : 300
  const mdAbove = useMediaQuery(theme.breakpoints.up('md'))

  const [chat, setChat] = useState(true)
  const [calls, setCalls] = useState(false)
  const [headImg, setHaedImg] = useState('/images/whatsapp/1.jpg')

  const [contacts, setContacts] = useState(false)
  const { t } = useTranslation('common')

  // 设备切换时重置侧栏滚动并重拉 WhatsApp 摘要
  useDeviceScopedInit(
    useCallback(() => {
      dispatch(fetchUserProfile())
    }, [dispatch])
  )
  const handleLeftSidebarToggle = () => setLeftSidebarOpen(prev => !prev)
  const handleUserProfileLeftSidebarToggle = () => setUserProfileLeftOpen(prev => !prev)
  const handleUserProfileRightSidebarToggle = () => setUserProfileRightOpen(prev => !prev)

  useEffect(() => {
    dispatch(setCurrentTab('Whatsapp'))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch])

  const fetchLoading = [true, 'true'].includes(store.fetchLoading)

  return (
    <>
      <div className='relative bg-[#009788] bg-[100px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex items-center justify-center'>
        <div className='absolute w-full h-[88%] bg-[#E0DEE1] mt-[150px]'></div>
        <div className='w-[94%] h-[96%] flex items-center justify-center'>
          <Box
            className='app-chat'
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              borderRadius: 1,
              position: 'relative',
              boxShadow: skin === 'bordered' ? 0 : 6,
              ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}` })
            }}
          >
            {fetchLoading ? (
              <ContentLoading />
            ) : (
              <>
            <WhatsAppSideBar
              store={store}
              hidden={hidden}
              mdAbove={mdAbove}
              dispatch={dispatch}
              userStatus={userStatus}
              selectMessage={selectMessage}
              getInitials={getInitials}
              sidebarWidth={sidebarWidth}
              setUserStatus={setUserStatus}
              leftSidebarOpen={leftSidebarOpen}
              removeSelectedChat={removeSelectedChat}
              userProfileLeftOpen={userProfileLeftOpen}
              formatDateToMonthShort={formatDateToMonthShort}
              handleLeftSidebarToggle={handleLeftSidebarToggle}
              handleUserProfileLeftSidebarToggle={handleUserProfileLeftSidebarToggle}
              calls={calls}
              setCalls={setCalls}
              chat={chat}
              contacts={contacts}
              headImg={headImg}
              setChat={setChat}
              setHaedImg={setHaedImg}
              setContacts={setContacts}
            />
            {chat && (
              <WhatsAppContent
                store={store}
                hidden={hidden}
                mdAbove={mdAbove}
                dispatch={dispatch}
                getInitials={getInitials}
                sidebarWidth={sidebarWidth}
                userProfileRightOpen={userProfileRightOpen}
                handleLeftSidebarToggle={handleLeftSidebarToggle}
                headImg={headImg}
                setHaedImg={setHaedImg}
              />
            )}
              </>
            )}
          </Box>
        </div>
      </div>
      {Basic ? null : <EncryptionKey />}
    </>
  )
}

WhatsApp.contentHeightFixed = true

export default WhatsApp
